module.exports = __webpack_public_path__ + "static/media/Parking.125fe25a.png";